var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NoticeBar',{attrs:{"text":_vm.data.value,"background":_vm.data.background,"color":_vm.data.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }